// extracted by mini-css-extract-plugin
export var actionText = "_s3-4";
export var container = "_s3-0";
export var leftSection = "_s3-1";
export var rightSection = "_s3-2";
export var settingsButton = "_s3-6";
export var settingsIcon = "_s3-7";
export var shortcut = "_s3-5";
export var shortcutGroup = "_s3-3";